//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FooterTop from '~/components/footer/footerTop.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
import TopScreen from '~/components/TopScreen.vue'
import HowItWorks from '~/components/common/HowItWorkPayout.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    FeatureContainer,
    DescriptionCard,
    HowItWorks
  },
  head () {
    return {
      title: this.$t('footer.solutions.payout').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      hiw: {
        title: 'pagsmile-payout.block1.title',
        steps: [
          'pagsmile-payout.block3.item1',
          'pagsmile-payout.block3.item2',
          'pagsmile-payout.block3.item3',
          'pagsmile-payout.block3.item4',
          'pagsmile-payout.block3.item5'
        ],
        imgs: [
          require('@/assets/img/solutions/pagsmile-payout/b3-1.png'),
          require('@/assets/img/solutions/pagsmile-payout/b3-2.png'),
          require('@/assets/img/solutions/pagsmile-payout/b3-3.png'),
          require('@/assets/img/solutions/pagsmile-payout/b3-4.png'),
          require('@/assets/img/solutions/pagsmile-payout/b3-5.png')
        ]
      }
    }
  }
}
